module.exports = __webpack_public_path__ + "img/homepage-savings.f537b24.webp";